import { init } from '@shieldpay/wheeljack/remix/entry.client.tsx';

init();
